<template>
    <v-layout align-center justify-center style = 'width: 100%;'>
        <v-card flat>
            <v-layout column align-center justify-center my-3>
                <v-data-table
                    disable-sort
                    :headers = "header" 
                    :items = "grants" 
                    no-data-text='Доступы не назначены' 
                    :loading = 'indicator' 
                    :server-items-length = 'grants.length' 
                    hide-default-footer 
                    style='width: 100%;'
                >
                    <template v-slot:body = '{ items }'>
                        <tbody class = 'text-start'>
                            <tr v-for = "(item, i) in items" :key = "i">
                                <td>{{ item.mode_name }}</td>
                                <td>{{ item.mode_description }}</td>
                                <td>{{ displayFields[item.lookup_field] }}</td>
                                <td>{{ getLookupValue(item.lookup_field, item.lookup_value) }}</td>
                                <td>{{ modes[item.mode_edit] }}</td>
                                <td>{{ modes[item.mode_persons] }}</td>
                                <td>
                                    <v-btn class="mr-2 ml-0" icon small @click = 'updating = true; visibility = true; grant = item'>
                                        <v-icon small color='light-blue darken-1'>mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                    <v-btn class="mx-0" icon small @click = "deleteIndirectAccessConfirmation(item)">
                                        <v-icon :color = '$store.getters.uiAccent' small>delete_outline</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                            <tr>
                                <td 
                                    :colspan = "header.length + 1" 
                                    @click = 'grant = {}; visibility = true;' 
                                    v-if = '$store.getters.grantUsers > 3'
                                    style = 'cursor: pointer;'
                                >
                                    <v-flex style = 'width: 100%;' d-flex>
                                        <span class='subheading font-weight-bold'>Добавить доступ</span>
                                        <v-icon class = 'ml-auto mr-2' color = 'info'>add</v-icon>
                                    </v-flex>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </v-layout>
        </v-card>
        <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator' style = 'flex: 0 0 auto !important;'>
            <template v-slot:title>{{user.name}} {{user.lastname}}</template>
            <template v-slot:content>
                <v-form class = 'mx-4'>
                    <v-select 
                        v-model = 'grant.lookup_field' 
                        :items = "lookupFields" 
                        item-text="text" 
                        item-value="value" 
                        single-line 
                        label = 'Поле для поиска'
                    ></v-select>
                    <v-text-field 
                        v-if = 'grant.lookup_field == "name"'
                        v-model = 'grant.lookup_value' 
                        label = 'Значение'
                    ></v-text-field>
                    <v-select
                        v-else
                        v-model = 'grant.lookup_value'
                        :items = 'grant.lookup_field == "segment_id" ? projectSegments:projectVerticals'
                        :item-text = 'grant.lookup_field == "segment_id" ? "segment_name":"vertical_name"'
                        :item-value = 'grant.lookup_field == "segment_id" ? "segment_id":"vertical_id"'
                        label = 'Значение'
                    ></v-select>
                    <v-select 
                        v-model = 'grant.mode_edit' 
                        label='Доступ к изменению' 
                        :items = "defaultModes" 
                        item-text="text" 
                        item-value="value" 
                        single-line
                    ></v-select>
                    <v-select 
                        v-model = 'grant.mode_persons' 
                        label='Доступ к пользователям' 
                        :items = "defaultModes" 
                        item-text="text" 
                        item-value="value" 
                        single-line
                    ></v-select>
                    <v-text-field 
                        v-model = 'grant.mode_name' 
                        label = 'Название роли'></v-text-field>
                    <v-text-field 
                        v-model = 'grant.mode_description' 
                        label = 'Описание роли'
                    ></v-text-field>
                </v-form>
            </template>
            <template v-slot:action>
                <v-btn class = 'px-0 light-blue--text text--darken-2' :loading = 'indicator' block depressed @click = 'updating? updatePersonIndirectConnection():addPersonIndirectConnection()'>Применить</v-btn>
            </template>
        </dialog-generic>
    </v-layout>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'IndistinctGrants',
        props: ['grants', 'indicator', 'user'],
        components: {'dialog-generic': DialogGeneric},
        data: () => ({
            visibility: false,
            updating: false,
            indicatorSecondary: false,
            grant: {},
            header: [
                { text: 'Роль', value: 'mode_name' },
                { text: 'Описание роли', value: 'mode_description' },
                { text: 'Поле поиска', value: 'lookup_field' },
                { text: 'Значение', value: 'lookup_value' },
                { text: 'Содержимое', value: 'mode_edit' },
                { text: 'Пользователи', value: 'mode_persons' },
            ],
            modes: {
                'X': 'Полный доступ',
                'U': 'Создание и редактирование',
                'W': 'Редактирование',
                'R': 'Просмотр'
            },
            defaultModes: [
                { 'text': 'Чтение', 'value': 'R' },
                { 'text': 'Изменение', 'value': 'W' },
                { 'text': 'Удаление', 'value': 'X' },
                { 'text': 'Полное управление', 'value': 'U' }
            ],
            lookupFields: [
                { 'text': 'Сегмент проекта', 'value': 'segment_id' },
                { 'text': 'Вертикаль проекта', 'value': 'vertical_id' },
                { 'text': 'Название проекта', 'value': 'name' },
            ],
            displayFields: {
                'segment_id': 'Сегмент проекта',
                'vertical_id': 'Вертикаль проекта',
                'name': 'Название проекта',
                'segment': 'Сегмент проекта',
                'vertical': 'Вертикаль проекта',
            },
        }),
        computed: {
            projectSegments() {
                return this.$store.state.segments
            },
            projectVerticals() {
                return this.$store.state.verticals
            },
        },
        methods: {
            deleteIndirectAccessConfirmation(item) {
                this.grant = item;
                confirm('Удалить доступ?') && this.deletePersonIndirectConnection()
            },
            deletePersonIndirectConnection() {
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'uid': this.user.uid,
                    ...{ 'login': this.$store.getters.userLogin },
                    ...this.grant
                }
                this.$http.patch(this.$store.getters.endpoint + '/db/person/grants',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.grants = response.data
                        this.grants = this.grants.reduce((a, b) => { return a.concat(b) })
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'delete',
                                target: 'user_grant_indistinct'
                            },
                            once: false
                        })
                    } else {
                        console.log(response)
                    }
                })
            },
            updatePersonIndirectConnection() {
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                this.indicatorSecondary = true;
                let requestData = {
                    'uid': this.user.uid,
                    ...{ 'login': this.$store.getters.userLogin },
                    ...this.grant
                }
                this.$http.put(this.$store.getters.endpoint + '/db/person/grants',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.grants = response.data
                        this.grants = this.grants.reduce((a, b) => { return a.concat(b) });
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'update',
                                target: 'user_grant_indistinct'
                            },
                            once: false
                        })
                        this.visibility = false;
                        this.indicatorSecondary = false;
                    } else {
                        console.log(response)
                    }
                })
            },
            addPersonIndirectConnection() {
                this.indicatorSecondary = true;
                let requestHeaders = {
                    'Content-Type': 'application/json;charset=UTF-8'
                }
                let requestData = {
                    'uid': this.user.uid,
                    ...{ 'login': this.$store.getters.userLogin },
                    ...this.grant
                }
                this.$http.post(this.$store.getters.endpoint + '/db/person/grants',
                    requestData, {
                        headers: { ...this.$store.state.restrictedHeaders, ...requestHeaders }
                    }).then((r) => {
                    let response = r.body;
                    if (response.result) {
                        this.grants = response.data
                        this.grants = this.grants.reduce((a, b) => { return a.concat(b) });
                        this.$dataLayer.$emit('enrich', {
                            event: 'crud',
                            data: {
                                type: 'create',
                                target: 'user_grant_indistinct'
                            },
                            once: false
                        })
                        this.visibility = false;
                        this.indicatorSecondary = false;
                    } else {
                        console.log(response)
                    }
                })
            },
            getLookupValue(type, mean) {
                if (type == 'segment_id') {
                    let segment = this.projectSegments.filter( (v) => v.segment_id == mean)
                    return segment[0].segment_name
                }
                else if (type == 'vertical_id') {
                    let vertical = this.projectVerticals.filter( (v) => v.vertical_id == mean)
                    return vertical[0].vertical_name
                } else {
                    return mean
                }
            }
        }
    }
</script>